import { number, object, string } from "zod";

export const getProductReviewsRating = {
  input: string(),
  output: object({ rating: number(), numReviews: number() }).nullable(),
};
